import {
    DashboardSquare02Icon,
    CategoryIcon,
    ProductIcon,
    MarketAreaIcon,
    BlogIcon,
    GalleryIcon,
    TestimonialIcon,
    PartnerIcon,
    InquiryIcon,
    TeamIcon,
    // SettingIcon,
    CompanyIcon,
    SocialLinkIcon,
    LogoIcon,
    AnalyticsIcon,
    ArrowRight02Icon2,
    GalleryCategoryIcon,
    GalleryImageIcon,
    GalleryVideoIcon,
    FaqIcon,
    ColorThemeIcon
    // HomeIcon,
    // AboutUsIcon,
    // PrivacyPolicyIcon,
    // TermsAndConditionsIcon,
    // SEOContentIcon
  } from "../../assets/icons";

  const user = localStorage.getItem("userData");
  let userData = null;
  if (user) {
    userData = JSON.parse(user);
  }
  const type = userData?.data?.organization_type;

  export const GalleryContent = 
       [
        {
            title: "Category",
            icon: <GalleryCategoryIcon width={18} height={18} color="#444050" strokeWidth="2" />,
            link: `/gallery-categories`,
        },
        {
            title: "Image",
            icon: <GalleryImageIcon width={18} height={18} color="#444050" strokeWidth="2" />,
            link: `/gallery-images`,
        },
        {
          title: "Video",
          icon: <GalleryVideoIcon width={18} height={18} color="#444050" strokeWidth="2" />,
          link: `/gallery-videos`,
        },
    ]

  
  export const SidebarContent = [
    {
      title: "Dashboard",
      icon: (
        <DashboardSquare02Icon
          width={18}
          height={18}
          color="#444050"
          strokeWidth="2"
        />
      ),
      link: "/",
    },
    {
      title: "Categories",
      icon: (
        <CategoryIcon width={18} height={18} color="#444050" strokeWidth="2" />
      ),
      link: "/categories",
    },
    // {
    //   title: "Sub Categories",
    //   icon: (
    //     <CategoryIcon width={18} height={18} color="#444050" strokeWidth="2" />
    //   ),
    //   link: "/sub-categories",
    // },
    ...(type === "Product" || type === "Product/Service"
      ? [
          {
            title: "Products",
            icon: (
              <ProductIcon
                width={18}
                height={18}
                color="#444050"
                strokeWidth="2"
              />
            ),
            link: "/products",
          },
        ]
      : []),
    {
      title: "blogs",
      icon: (
        <BlogIcon width={18} height={18} color="#444050" strokeWidth="2" />
      ),
      link: "/blogs",
    },
    // {
    //   title: "tags",
    //   icon: (
    //     <BlogIcon width={18} height={18} color="#444050" strokeWidth="2" />
    //   ),
    //   link: "/tags",
    // },
    {
      title: "gallery",
      icon: <GalleryIcon width={18} height={18} color="#444050" strokeWidth="2" />,
      dropdownIcon: <ArrowRight02Icon2 width={18} height={18} color="#444050" strokeWidth="2" />, // Optional if needed
      link: `/galleries`, // Optional for fallback
      children: GalleryContent, 
    },
    {
      title: "testimonials",
      icon: (
        <TestimonialIcon width={18} height={18} color="#444050" strokeWidth="2" />
      ),
      link: "/testimonials",
    },
    {
      title: "clients",
      icon: (
        <PartnerIcon width={18} height={18} color="#444050" strokeWidth="2" />
      ),
      link: "/clients",
    },
    {
      title: "inquiries",
      icon: (
        <InquiryIcon width={24} height={24} color="#444050" strokeWidth="1.5" />
      ),
      link: "/inquiries",
    },
    {
      title: "Target Regions",
      icon: (
        <MarketAreaIcon width={18} height={18} color="#444050" strokeWidth="2" />
      ),
      link: "/target-regions",
    },
    {
      title: "teams",
      icon: (
        <TeamIcon width={18} height={18} color="#444050" strokeWidth="2" />
      ),
      link: "/teams",
    },
    {
      title: "page",
      icon: (
        <GalleryIcon width={18} height={18} color="#444050" strokeWidth="2" />
      ),
      link: "/pages",
    },
    {
      title: "FAQs",
      icon: <FaqIcon width={18} height={18} color="#444050" strokeWidth="2" />,
      link: `/faqs`,
    },
    // {
    //   title: "settings",
    //   icon: (
    //     <SettingIcon width={18} height={18} color="#444050" strokeWidth="2" />
    //   ),
    //   link: "/settings",
    // },
  ];

  export const ConfigurationContent = [
    // {
    //   title: "general",
    //   icon: (
    //     <SettingIcon width={18} height={18} color="#444050" strokeWidth="2" />
    //   ),
    //   link: "/general",
    // },
    {
      title: "Company Details",
      icon: <CompanyIcon width={18} height={18} color="#444050" strokeWidth="2" />,
      link: `/company-details`,
    },
    // {
    //     title: "Contact Us",
    //     icon: <SettingIcon width={18} height={18} color="#444050" strokeWidth="2" />,
    //     link: `/contact-us`,
    // },
    {
        title: "Social Links",
        icon: <SocialLinkIcon width={18} height={18} color="#444050" strokeWidth="2" />,
        link: `/social-links`,
    },
    {
        title: "Logo",
        icon: <LogoIcon width={18} height={18} color="#444050" strokeWidth="2" />,
        link: `/logo`,
    },
    {
        title: "Google Analytics",
        icon: <AnalyticsIcon width={18} height={18} color="#444050" strokeWidth="2" />,
        link: `/google-analytics`,
    },
    // {
    //   title: "Home",
    //   icon: (
    //     <HomeIcon width={18} height={18} color="#444050" strokeWidth="2" />
    //   ),
    //   link: "/home-page",
    // },
    // {
    //   title: "About Us",
    //   icon: (
    //     <AboutUsIcon width={18} height={18} color="#444050" strokeWidth="2" />
    //   ),
    //   link: "/about-us",
    // },
    // {
    //   title: "Privacy Policy",
    //   icon: (
    //     <PrivacyPolicyIcon width={18} height={18} color="#444050" strokeWidth="2" />
    //   ),
    //   link: "/privacy-policy",
    // },
    // {
    //   title: "Terms & Condition",
    //   icon: (
    //     <TermsAndConditionsIcon width={18} height={18} color="#444050" strokeWidth="2" />
    //   ),
    //   link: "/terms-conditions",
    // },
    // {
    //   title: "SEO Configuration",
    //   icon: (
    //     <SEOContentIcon width={18} height={18} color="#444050" strokeWidth="2" />
    //   ),
    //   link: "/seo-configuration",
    // },
  ]
  
  export const ThemeConfigurationContent = [
  {
    title: "Color Configuration",
    icon: (
      <ColorThemeIcon
        width={18}
        height={18}
        color="#444050"
        strokeWidth="2"
      />
    ),
    link: "/color-configuration",
  },
];
  export const getOrganizationThemeConfigurationContent = (selectedOrganizationId) => {
  return [
    {
      title: "Color Configuration",
      icon: (
        <ColorThemeIcon
          width={18}
          height={18}
          color="#444050"
          strokeWidth="2"
        />
      ),
      link: `/organization/${selectedOrganizationId}/color-configuration`,
    },
  ];
};